// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.atm-title[data-v-39a107aa] {\n  font-size: 1.25rem;\n}\n.atm-btn[data-v-39a107aa] {\n  width: 100%;\n  font-size: 1.25rem;\n  line-height: 37px;\n}\n[dir] .atm-btn[data-v-39a107aa] {\n  padding: 0.8rem 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
